export const tripReducerSelector = state => state.tripReducer;
